import { useAuth0 } from "@auth0/auth0-react";
import Typography from "@material-ui/core/Typography";
import PollIcon from "@material-ui/icons/Poll";
import React from "react";

import CircularProgress from "@material-ui/core/CircularProgress";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CostByStagesTable from "./CostByStagesTableWithWidths";

import { Paper, Popover } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import CloseIcon from "@material-ui/icons/Close";
import LibraryIcon from '@material-ui/icons/LocalLibraryOutlined';
import ArrowIcon from '@material-ui/icons/KeyboardBackspace';

import Tooltip from "@material-ui/core/Tooltip";

import RankingChart from "./RankingChart"
import OPKTable from "./OPKTable"
import ProfitTable from "./ProfitTable"

import { apiurl } from '../app/prefs.js';
import TinyChart from "./TinyChart";
import { ReactComponent as XlsIcon } from './xlsx.svg';

import { Dialog, DialogContent } from '@material-ui/core';

import MonthSelect from "./MonthSelection";

import AccountFilter from './AccountFilter.js';

const VideoIcon = (props) => (
    <svg
        class="svg-icon"
        width='26px'
        height='26px'
        color='#0b6471'
        viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M725.333333 574.506667l170.666667 113.770666V335.722667l-170.666667 113.770666v125.013334z m0-227.562667l189.653334-126.442667C943.36 201.6 981.333333 221.930667 981.333333 256v512c0 34.069333-37.973333 54.4-66.346666 35.498667L725.333333 677.056v48.106667C725.333333 784.085333 677.504 832 618.752 832H149.248A106.666667 106.666667 0 0 1 42.666667 725.162667V298.837333C42.666667 239.914667 90.496 192 149.248 192h469.504A106.666667 106.666667 0 0 1 725.333333 298.837333v48.106667zM128 298.837333v426.325334A21.333333 21.333333 0 0 0 149.248 746.666667h469.504c11.584 0 21.248-9.685333 21.248-21.504V298.837333A21.333333 21.333333 0 0 0 618.752 277.333333H149.248C137.664 277.333333 128 287.018667 128 298.837333z" fill="#0b6471" /></svg>
)

const PlayIcon = () => (
    <svg width="40px" height="40px" viewBox="-1 0 14 14" id="meteor-icon-kit__solid-play-s" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_iconCarrier"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 1.00154V13.0015C0 13.7788 0.84797 14.259 1.5145 13.859L11.5145 7.859C12.1618 7.4706 12.1618 6.5325 11.5145 6.1441L1.5145 0.14405C0.84797 -0.25586 0 0.22425 0 1.00154z" fill="#758CA3"></path></g></svg>
)

export default function Report038() {
    const [totalData, setTotalData] = React.useState(undefined);
    const [totalDataLoaded, setTotalDataLoaded] = React.useState(false);
    const [noData, setNoData] = React.useState(false);

    const [selectedYear, setSelectedYear] = React.useState(1);
    const [years, setYears] = React.useState([]);
    const [selectedMonths, setSelectedMonths] = React.useState([]);
    const [reportInfoOpen, setReportInfoOpen] = React.useState(false);

    const { getAccessTokenSilently, user } = useAuth0();

    const [videoListOpen, setVideoListOpen] = React.useState(false);
    const [videoPlayDialogOpen, setVideoPlayDialogOpen] = React.useState(false);


    const [opkFilterItems, setOPKFilterItems] = React.useState([]);
    const [selectedOPK, setSelectedOPK] = React.useState([]);
    const [opkFilterStatus, setOPKFilterStatus] = React.useState('None');
    const [opkIdnName, setOpkIdnName] = React.useState('');

    const applyOPKFilter = async (accounts) => {

        const getFilterStatus = () => {
            if (accounts.length === 0) {
                return "None";
            }
            let accountCount = 0;
            const menuData = opkFilterItems;
            for (let c = 0; c < menuData.length; c++) {
                if (menuData[c].children && menuData[c].children.length !== 0) {
                    accountCount = accountCount + menuData[c].children.length;
                } else {
                    accountCount = accountCount + 1;
                }
            }
            if (accountCount === 1) {
                return "One";
            };
            if (accountCount === accounts.length) {
                return "All";
            } else {
                return "Selected";
            }
        };

        setOPKFilterStatus(getFilterStatus());
        setTotalDataLoaded(false);
        loadDataForOPK(accounts);
        setSelectedOPK(accounts);
        if (accounts.length == 1) setOpkIdnName(getOpkIdnName(accounts[0])); else setOpkIdnName('');

        setTotalDataLoaded(true);
    };

    const handleVideoListClose = () => {
        setVideoListOpen(false)
    };

    const videoData = [
        {
            image: '/manual/reports/Raport_OPK_Finalne.jpg',
            video: '/manual/reports/Raport_OPK_Finalne.mp4'
        },
    ];

    const [selectedVideo, setSelectedVideo] = React.useState(videoData[0]);

    const handleVideoSelect = (video) => {
        setSelectedVideo(video);
        setVideoListOpen(false);
        setVideoPlayDialogOpen(true);
    };

    const VideoList = () => {
        return <div>
            {
                videoData.map(
                    (v, i) => {
                        return <div className="videoListItem" onClick={() => handleVideoSelect(v)}>
                            <div style={{ position: 'relative' }}>
                                <img src={v.image} alt={'Video nr ' + i} />
                                <div style={{
                                    position: 'absolute',
                                    top: '90px',
                                    left: '190px',
                                    opacity: '.5',
                                    color: 'gray'
                                }}>
                                    <PlayIcon />
                                </div>
                            </div>
                        </div>
                    }
                )
            }
        </div>
    }


    const loadData = (param) => {
        setTotalDataLoaded(false);
        const apiUrl = `${apiurl}/getopkresults`;
        getAccessTokenSilently().then((token) => {
            const requestOptions = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token,
                },
            };
            fetch(apiUrl, requestOptions)
                .then((res) => res.json())
                .then((fetchedData) => {

                    if (fetchedData.error !== undefined) {
                        setNoData(true);
                    } else {
                        // below - code to setup OPK filter during first data load
                        if (param === 'first' && fetchedData.details && Array.isArray(fetchedData.details)) {
                            const dictionary = fetchedData.details.map(
                                parent => {
                                    const children = parent.children.map(
                                        child => ({ id: child.id, name: child.name })
                                    );
                                    return ({
                                        id: parent.parent_id,
                                        name: parent.parent_name,
                                        children: children
                                    })
                                }
                            );
                            const defaultSelected = [];
                            /*
                            dictionary.forEach(parent => {
                                parent.children.forEach(
                                    child => defaultSelected.push(child.id)
                                )
                            });
                            */
                            setOPKFilterItems(dictionary);
                            setSelectedOPK(defaultSelected);
                        };

                        setYears(fetchedData.availableYears.map(year => year.YEAR.toString()));
                        setSelectedYear(fetchedData.selectedYear.selectedYear);
                        setTotalData(fetchedData);
                        setTotalDataLoaded(true);
                    };
                });
        });
    };

    const loadDataForOPK = (opkList) => {
        setTotalDataLoaded(false);
        const apiUrl = `${apiurl}/getopkresults/${selectedYear}/${JSON.stringify(selectedMonths)}`;
        getAccessTokenSilently().then((token) => {
            const requestOptions = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token,
                }
            };
            //console.log(opkFilterItems.length);
            //console.log(opkList.length);
            if (opkFilterItems.reduce((c, p) => c + p.children.length, 0) >= opkList.length) {
                Object.assign(
                    requestOptions, {
                    body: JSON.stringify(
                        {
                            "opkList": JSON.stringify(opkList)
                        })
                }
                );
            };
            fetch(apiUrl, requestOptions)
                .then((res) => res.json())
                .then((fetchedData) => {
                    setTotalData(fetchedData);
                    setTotalDataLoaded(true);
                });
        });
    };

    const loadDataForYear = (year, currentSelectedOPK) => {
        setTotalDataLoaded(false);
        const apiUrl = `${apiurl}/getopkresults/${year}/${JSON.stringify(selectedMonths)}`;
        getAccessTokenSilently().then((token) => {
            let requestOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    Authorization: "Bearer " + token,
                }
            };
            if (opkFilterStatus === 'Selected' || opkFilterStatus === 'One') {
                requestOptions = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: "Bearer " + token,
                    },
                    body: JSON.stringify(
                        {
                            "opkList": JSON.stringify(selectedOPK)
                        })
                }
            }
            fetch(apiUrl, requestOptions)
                .then((res) => res.json())
                .then((fetchedData) => {

                    if (fetchedData && fetchedData.details && Array.isArray(fetchedData.details)) {
                        const dictionary = fetchedData.details.map(
                            parent => {
                                const children = parent.children.map(
                                    child => ({ id: child.id, name: child.name })
                                );
                                return ({
                                    id: parent.parent_id,
                                    name: parent.parent_name,
                                    children: children
                                })
                            }
                        );
                        let defaultSelected = [];

                        dictionary.forEach(parent => {
                            parent.children.forEach(
                                child => defaultSelected.push(child.id)
                            )
                        });

                        defaultSelected = defaultSelected.filter(item => currentSelectedOPK.includes(item));

                        setOPKFilterItems(dictionary);
                        setSelectedOPK(defaultSelected);

                        //applyOPKFilter(dictionary);

                        // if (defaultSelected.length == 0) {
                        //     setOPKFilterStatus('None');
                        //     setNoData(true);
                        // } else {

                        // }

                        if (defaultSelected.length == 0) Object.assign(fetchedData, { monthlydata: undefined })

                        setTotalData(fetchedData);
                        setTotalDataLoaded(true);

                    };



                });
        });
    };

    const loadDataForMonths = (year, months) => {
        setTotalDataLoaded(false);
        const apiUrl = `${apiurl}/getopkresults/${year}/${JSON.stringify(months)}`;
        getAccessTokenSilently().then((token) => {
            let requestOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    Authorization: "Bearer " + token,
                }
            };
            if (opkFilterStatus === 'Selected' || opkFilterStatus === 'One') {
                requestOptions = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: "Bearer " + token,
                    },
                    body: JSON.stringify(
                        {
                            "opkList": JSON.stringify(selectedOPK)
                        })
                }
            }
            fetch(apiUrl, requestOptions)
                .then((res) => res.json())
                .then((fetchedData) => {
                    setTotalData(fetchedData);
                    setTotalDataLoaded(true);

                });
        });
    };

    const downloadFile = (downloadURL) => {

        getAccessTokenSilently().then((token) => {
            document.body.style.cursor = 'wait';
            const apiUrl = downloadURL;
            let requestOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    Authorization: "Bearer " + token,
                }
            };
            if (opkFilterStatus === 'Selected' || opkFilterStatus === 'One') {
                requestOptions = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: "Bearer " + token,
                    },
                    body: JSON.stringify(
                        {
                            "opkList": JSON.stringify(selectedOPK)
                        })
                }
            }
            fetch(apiUrl, requestOptions)
                .then((response) => response.blob())
                .then((blob) => {
                    // Create blob link to download
                    const url = window.URL.createObjectURL(
                        new Blob([blob]),
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute(
                        'download',
                        `WynikiOPK.xlsx`,
                    );
                    // Append to html link element page
                    document.body.appendChild(link);
                    // Start download
                    link.click();
                    // Clean up and remove the link
                    link.parentNode.removeChild(link);
                    document.body.style.cursor = 'auto';
                });
        });

    };

    const getOpkIdnName = (lookupid) => {
        const opkFilterItems = totalData.details;
        //console.log(lookupid);
        let res = '';
        for (let i = 0; i < opkFilterItems.length; i++) {
            if (opkFilterItems[i].id == lookupid)
                res = opkFilterItems[i].name + ' - ' + opkFilterItems[i].id;
            if (opkFilterItems[i].children)
                opkFilterItems[i].children.forEach((child) => {
                    if (child.id == lookupid) res = child.name + ' - ' + child.id;
                });
        };
        //console.log(res);
        return res;
    };

    React.useEffect(() => {
        let mounted = true;
        loadData('first');
        return function cleanup() {
            mounted = false;
        };
    }, []);

    React.useEffect(() => {
        if (selectedYear)
            loadDataForYear(selectedYear, selectedOPK);

    }, [selectedYear]);



    function YearBox() {
        return (
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-end' }}>
                <Autocomplete
                    id="combo-box"
                    disabled={years.length <= 1}
                    options={years}
                    value={selectedYear}
                    size="small"
                    disableClearable
                    autoHighlight
                    getOptionLabel={(option) => option}
                    getOptionSelected={(option, value) => {
                        if (!value) return false;
                        return option === value;
                    }}
                    style={{ width: "120px", marginBottom: "0px", marginLeft: '0px', marginRight: '10px' }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="Rok"
                            variant="filled"
                            InputProps={{
                                ...params.InputProps,
                                disableUnderline: true,
                                style: {
                                    backgroundColor: "#e7f0f1",
                                    color: "#0B6471",
                                    fontSize: "14px",
                                },
                            }}
                        />
                    )}
                    onChange={(event, value) => {
                        if (value) {
                            setSelectedYear(value);
                            //loadDataForYear(value);
                        }
                    }}
                />
            </div>
        );
    }



    return (
        <div className="App" style={{ position: "relative" }}>
            <div
                style={{
                    //background: "linear-gradient(to right, #0b6471, #9BC0C5)",
                    display: "flex",
                    height: "55px",
                    width: "100%",
                    backgroundColor: "#0b6471",
                    color: "white",
                    borderRadius: "5px",
                    paddingTop: "0px",
                    paddingLeft: "0px",
                    alignItems: "center",
                }}
            >
                <div style={{ width: "80px", marginTop: "5px" }}>
                    <PollIcon
                        style={{
                            marginLeft: "20px",
                            marginRight: "20px",
                            fontSize: "42px",
                        }}
                    />
                </div>
                <div>
                    <Typography variant="h5" style={{ color: "white" }}>
                        Wyniki OPK
                    </Typography>
                </div>
            </div>

            {totalData ? (
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        transition: "opacity 0.5s",
                        opacity: totalDataLoaded ? "1" : "0.2",
                        paddingTop: '5px',
                    }}
                >
                    <div
                        style={{
                            display: "flex", justifyContent: "flex-start", backgroundColor: 'white', padding: '5px', borderRadius: '5px', padding: '5px', marginBottom: '5px', marginRight: '1px'
                        }}
                    >
                        <YearBox />
                        <div style={{ marginRight: '10px', backgroundColor: '#e7f0f1', borderRadius: '5px', padding: '5px 0px 0px 5px' }}>
                            <MonthSelect
                                version={2}
                                setSelectedMonthsFunction={setSelectedMonths}
                                loadDataFunction={loadDataForMonths}
                                selectedMonthsProperty={selectedMonths}
                                startDateProperty={{ year: selectedYear }}
                            />
                        </div>
                        <div style={{ marginRight: '10px', backgroundColor: '#e7f0f1', borderRadius: '5px', padding: '5px 0px 0px 5px' }}>
                            <AccountFilter
                                titleCaption="OPK"
                                underLine={true} //disable underline
                                fontSize='14px'
                                fontStyle='italic'
                                fontColor='rgb(11, 100, 113)'
                                marginTop='-3px'
                                menuData={opkFilterItems}
                                startSelection={selectedOPK}
                                updateFunction={applyOPKFilter}
                            />
                        </div>
                        <div style={{ display: 'none' }}>
                            <Tooltip title='Opis raportu'>
                                <Button
                                    id='reportInfoIcon'
                                    onClick={() => setReportInfoOpen(true)}
                                    style={{
                                        marginTop: "0px",
                                        width: "48px",
                                        minWidth: "48px",
                                        height: "46px",
                                        backgroundColor: "#e7f0f1",
                                        color: "#0B6471",
                                        borderRadius: "5px",
                                        marginRight: '10px',
                                    }}
                                >
                                    <LibraryIcon
                                        style={{ width: "30px", height: "30px" }}
                                    />
                                </Button>
                            </Tooltip>
                        </div>


                        <Tooltip title='Pobierz raport jako XLS'>
                            <Button
                                id='saveXLS'
                                disabled={opkFilterStatus == 'None'}
                                onClick={
                                    () => downloadFile(`${apiurl}/getopkresults/${selectedYear}/${JSON.stringify(selectedMonths)}/xls`)
                                }
                                style={{
                                    marginTop: "0px",
                                    width: "48px",
                                    minWidth: "48px",
                                    height: "46px",
                                    backgroundColor: "#e7f0f1",
                                    color: "#0B6471",
                                    borderRadius: "5px",
                                    marginRight: '10px',
                                }}
                            >
                                <XlsIcon
                                    style={{ marginTop: '0px', cursor: 'pointer', fill: '#0B6471', height: '22px' }}
                                />
                            </Button>
                        </Tooltip>

                        <div style={{}}>
                            <Tooltip title='Instrukcje video'>
                                <Button
                                    id='video'
                                    onClick={
                                        () => setVideoPlayDialogOpen(true)
                                    }
                                    style={{
                                        marginTop: "0px",
                                        width: "48px",
                                        minWidth: "48px",
                                        height: "46px",
                                        backgroundColor: "#e7f0f1",
                                        color: "#0B6471",
                                        borderRadius: "5px",
                                        marginRight: '10px',
                                    }}
                                > <sup style={{ position: 'absolute', color: '#FE8E3C', fontWeight: 'bold', top: '0px', left: '4px' }}>N</sup>
                                    <VideoIcon
                                        style={{ color: '#0B6471', marginTop: '2px', cursor: 'pointer' }}
                                    />
                                </Button>
                            </Tooltip>
                        </div>

                    </div>

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            flexWrap: "wrap",
                            overflow: "auto",

                        }}
                    >


                        {totalData.monthlydata && totalData.monthlydata.length != 0 ?
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    flexWrap: "wrap",
                                    overflow: "auto",
                                    transition: "opacity 0.5s",
                                    opacity: totalDataLoaded ? "1" : "0.2",
                                }}
                            >

                                <div id="top chart area" style={{ display: "flex", flexWrap: "wrap", width: "100%", flexDirection: "row" }}>
                                    <div id="left chart area" style={{ display: "flex", flexWrap: "wrap", maxWidth: "840px", flexDirection: "column", flexShrink: 1 }}>
                                        <div id="tiny charts area" style={{ display: "flex", flexWrap: "wrap", width: "100%", flexDirection: "row", flexShrink: 1 }}>
                                            <TinyChart
                                                title="WYNIK" data={totalData} datatype="profit"
                                                actual={totalData.yearlydata.profit.toLocaleString("pl-PL", { maximumFractionDigits: 0, }) + " zł"}
                                                budget={totalData.budgetdata.profit_BU && totalData.budgetdata.profit_BU.toLocaleString("pl-PL", { maximumFractionDigits: 0, }) + "%"}
                                                color="#4E97A5"
                                            />
                                            <TinyChart
                                                title="PRZYCHODY" data={totalData} datatype="income"
                                                actual={totalData.yearlydata.income.toLocaleString("pl-PL", { maximumFractionDigits: 0, }) + " zł"}
                                                budget={totalData.budgetdata.income_BU && totalData.budgetdata.income_BU.toLocaleString("pl-PL", { maximumFractionDigits: 0, }) + "%"}
                                                color="#BFFBFF"
                                            />
                                            <TinyChart
                                                title="KOSZTY" data={totalData} datatype="cost"
                                                actual={totalData.yearlydata.cost.toLocaleString("pl-PL", { maximumFractionDigits: 0, }) + " zł"}
                                                budget={totalData.budgetdata.cost_BU && totalData.budgetdata.cost_BU.toLocaleString("pl-PL", { maximumFractionDigits: 0, }) + "%"}
                                                color="#0B6471"
                                            />
                                        </div>
                                        <div id="top 3 bottom 3 tables area" style={{ display: "flex", paddingRight: "10px", alignItems: "stretch", flexWrap: "wrap", width: "100%", flexDirection: "row", flexGrow: 1, flexShrink: 1 }}>
                                            <ProfitTable
                                                title="RANKING KOSZTÓW WYNAGRODZEŃ WG GRUP PRACOWNICZYCH"
                                                data={totalData.salaries_by_group}
                                                dataType="cost"
                                                columns={[
                                                    {
                                                        name: "Grupa pracownicza",
                                                        align: "left",
                                                        style: { color: "#0b6471", borderBottom: "1px solid" },
                                                        datadef: "group_name",
                                                        datalen: "",
                                                    },
                                                    {
                                                        name: "BU",
                                                        align: "right",
                                                        style: { color: "#0b6471", borderBottom: "5px double" },
                                                        datadef: "cost_bu",
                                                        datalen: 0,
                                                    },
                                                    {
                                                        name: "Δ %",
                                                        align: "right",
                                                        style: { color: "#0b6471", borderBottom: "1px solid" },
                                                        datadef: "cost_delta",
                                                        datalen: 2,
                                                    },
                                                    {
                                                        name: "Koszt wynagrodzeń",
                                                        align: "right",
                                                        style: { color: "#0b6471", borderBottom: "4px solid" },
                                                        datadef: "cost",
                                                        datalen: 0,
                                                    },
                                                    {
                                                        name: "Udział w przychodzie [%]",
                                                        align: "right",
                                                        style: { color: "#0b6471", borderBottom: "4px solid" },
                                                        datadef: "cost_in_income",
                                                        datalen: 2,
                                                    },
                                                ]}
                                            />
                                        </div>
                                    </div>
                                    <div id="right chart area" style={{ borderColor: "2px red solid", display: "flex", flexGrow: 1, flexWrap: "wrap", width: "220px", flexDirection: "row" }}>
                                        <RankingChart title="RANKING OPK WG WYNIKU" color="#4E97A5" data={totalData.opkranking} opk_name={opkIdnName} showAllValues={true} />
                                    </div>
                                </div>

                                <CostByStagesTable
                                    title='ANALIZA POZIOMÓW MARŻ'
                                    dimUnexpanded='true'
                                    data={totalData.margins}
                                    columnWidths={['400px', '180px', '140px','140px', '180px', '180px', 'auto']}
                                    rowHeight={20}
                                    columns={
                                        [
                                            { name: '', value: 'label', align: 'left', type: 'text', underline: '1px solid', marginType: 'cost' },
                                            { name: <div><div style={{ fontWeight: "400" }}>Wartość</div></div>, value: 'total', align: 'right', type: 'profit', underline: '5px double' },
                                            { name: <div style={{ fontWeight: "400" }}>%</div>, value: 'pct', align: 'right', type: 'percent', underline: '2px solid' },
                                            { name: <div style={{ fontWeight: "400" }}></div>, value: 'months', align: 'right', type: 'tinychart', underline: '4px solid' },

                                            totalData.margins[0].perDischarge != undefined ?
                                            { name: <div style={{ fontWeight: "400" }}>na 1 wypisanego</div>, value: 'perDischarge', align: 'right', type: 'profit', underline: '2px solid' }
                                            : totalData.margins[0].perConsultation != undefined ?
                                            { name: <div style={{ fontWeight: "400" }}>na 1 poradę</div>, value: 'perConsultation', align: 'right', type: 'profit', underline: '2px solid' }
                                            :
                                            { name: '', value: '', align: 'right', type: 'profit', underline: '2px solid' },

                                            totalData.margins[0].perDay != undefined ?
                                            { name: <div style={{ fontWeight: "400" }}>na 1 osobodzień</div>, value: 'perDay', align: 'right', type: 'profit', underline: '2px solid' }
                                            :
                                            { name: '', value: '', align: 'right', type: 'profit', underline: '2px solid' },                                            

                                            { name: '', value: '', align: 'right', type: 'profit', underline: '2px solid' },

                                        ]
                                    }
                                />

                                <OPKTable data={totalData} />


                                <CostByStagesTable
                                    title='DANE STATYSTYCZNE'
                                    dimUnexpanded='true'
                                    data={totalData.statistics}
                                    maximumFractionDigits='0'
                                    columns={
                                        [
                                            { name: 'Wskaźnik', value: 'name', align: 'left', type: 'text', underline: '1px solid' },
                                            { name: <div><div style={{ fontWeight: "400" }}>Wartość</div></div>, value: 'value', align: 'right', type: 'text', underline: '5px double' },
                                            { name: <div><div style={{ fontWeight: "400" }}></div></div>, value: 'monthly', align: 'right', type: 'tinychart', underline: '5px double' },
                                        ]
                                    }
                                />

                            </div>
                            : selectedOPK.length === 0 && <Typography style={{ position: "absolute", top: "150%", left: "45%", color: "#0b6471", textJustify: "left" }} variant="h5">Wybierz OPK</Typography>}
                        {!totalDataLoaded && <CircularProgress style={{ position: "absolute", height: "70px", width: "70px", top: totalData.yearlydata ? "50%" : "120%", left: "50%", color: "#0b6471", opacity: "0.6" }} />}



                    </div>

                    <Popover
                        id='hintPopOver'
                        open={reportInfoOpen}
                        anchorEl={document.getElementById('reportInfoIcon')}
                        onClose={() => setReportInfoOpen(false)}
                        anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "center"
                        }}
                    >
                        <Paper
                            style={{
                                padding: "10px",
                                width: "600px",
                                fontFamily: "roboto",
                                display: "flex",
                                flexDirection: "column"
                            }}
                        >
                            <div
                                style={{
                                    top: "0px",
                                    display: "flex",
                                    width: "100%",
                                    justifyContent: "right"
                                }}
                            >
                                <CloseIcon style={{ cursor: 'pointer', fontSize: '16px' }} onClick={() => setReportInfoOpen(false)} />
                            </div>
                            <div style={{ fontSize: '16px', padding: '5px', marginBottom: '5px' }}>
                                <p>Raport zawiera <b>wyniki, przychody oraz koszty całkowite</b> (suma kosztów bezpośrednich i doliczonych)
                                    dla poszczególnych komórek (Ośrodków Powstawania Kosztów).</p>
                                <p>Raport nie pokazuje kosztów poszczególnych komórek pomocniczych i proceduralnych, ponieważ
                                    zgodnie z wymogami Standardu Rachunku Kosztów, zostały one rozliczone na inne komórki widoczne
                                    w raporcie. Analiza kosztów utrzymania tych komórek dostępna jest w raportach: <b>OPK Pomocnicze</b> oraz <b>OPK Proceduralne</b>.</p>
                            </div>
                            <div
                                style={{
                                    top: "60px",
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    borderTop: '1px #0B6471 solid'
                                }}
                            >
                                <Button onClick={() => setReportInfoOpen(false)}>
                                    Zakończ
                                </Button>
                            </div>
                        </Paper>
                    </Popover>
                </div>
            ) : (
                (!totalData && !noData) && (
                    <Typography
                        style={{
                            position: "absolute",
                            top: "120%",
                            left: "40%",
                            color: "#0b6471",
                            textJustify: "left",
                        }}
                        variant="h5"
                    >
                        Wczytywanie danych
                    </Typography>
                )
            )}
            {(!totalDataLoaded && !noData && false) && (
                <CircularProgress
                    style={{
                        position: "absolute",
                        height: "70px",
                        width: "70px",
                        top: totalData ? "50%" : "120%",
                        left: "50%",
                        color: "#0b6471",
                        opacity: "0.6",
                    }}
                />
            )}

            <Popover
                id='videoSelectPopOver'
                open={totalDataLoaded && videoListOpen}
                anchorEl={document.getElementById('video')}
                onClose={handleVideoListClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center"
                }}
            >
                <Paper
                    style={{
                        padding: "10px",
                        width: "450px",
                        fontFamily: "roboto",
                        display: "flex",
                        flexDirection: "column",
                        //height: 'calc(100vh - 270px)'
                    }}
                >

                    <div
                        style={{
                            top: "0px",
                            display: "flex",
                            width: "100%",
                            justifyContent: "right"
                        }}
                    >

                        <CloseIcon style={{ cursor: 'pointer', fontSize: '16px' }} onClick={() => handleVideoListClose()} />

                    </div>

                    <VideoList />

                </Paper>
            </Popover>
            <Dialog

                maxWidth='90vw'
                open={videoPlayDialogOpen}
                onClose={() => setVideoPlayDialogOpen(false)}
                aria-labelledby="dialog-title"
                aria-describedby="dialog-description"

            >
                <DialogContent style={{ display: 'flex', flexDirection: 'column', margin: '0px', padding: '0px' }}>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '3px 10px 3px 0px' }}>
                        <button
                            onClick={() => {
                                const div = document.getElementById('videoControl');
                                if (div.requestFullscreen)
                                    div.requestFullscreen();
                                else if (div.webkitRequestFullscreen)
                                    div.webkitRequestFullscreen();
                                else if (div.msRequestFullScreen)
                                    div.msRequestFullScreen();
                            }
                            }
                            style={{ backgroundColor: 'white', color: '#0b6471', fontWeight: 'bold', textDecorationLine: 'underline' }}
                        >
                            Pełen ekran
                        </button>
                        <button
                            onClick={() => setVideoPlayDialogOpen(false)}
                            style={{ backgroundColor: 'white', color: '#0b6471', fontWeight: 'bold', textDecorationLine: 'underline' }}
                        >
                            Zamknij
                        </button>
                    </div>
                    <video id='videoControl' controls autoPlay style={{ width: '80vw' }}>
                        <source src={selectedVideo && selectedVideo.video} type="video/mp4" />
                        Video control not supported by browser
                    </video>

                </DialogContent>
            </Dialog>
        </div>

    );
}
